import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/foot-watch/$diaryId/_view/progress")({
    component: () => <div>Hello /_app/foot-watch/$diaryId/progress!</div>,
});
